import { useMsal } from "@azure/msal-react";
import { useUserContext } from "../contexts";
import { CreateAuditLogRequest } from "../models";
import isEmpty from "lodash/isEmpty";
import { BuildUrl } from "../helpers";
import { apiAccessRequest } from "../constants";
import { useCallback } from "react";

export const useCreateAuditLog = () => {
	const { account } = useUserContext();
	const { instance } = useMsal();

	const createAuditLog = useCallback(
		async (createAuditLogRequest: CreateAuditLogRequest[]) => {
			if (isEmpty(createAuditLogRequest)) {
				throw new Error("CreateAuditLog received an empty payload");
			}

			const requestUrl = BuildUrl("AuditLog");

			const tokenResponse = await instance.acquireTokenSilent({
				account,
				scopes: apiAccessRequest.scopes
			});

			const headers = {
				Authorization: `Bearer ${tokenResponse.accessToken}`,
				"Content-Type": "application/json"
			};

			const response = await fetch(requestUrl, {
				method: "POST",
				headers,
				body: JSON.stringify(createAuditLogRequest)
			});

			if (!response.ok) {
				throw new Error("Failed to create audit log");
			}
		},
		[account, instance]
	);

	return { createAuditLog };
};
